export const auth = {
  actions: {
    signOut: 'Sign out',
    retry: 'Retry',
    contactSupport: 'Contact support',
  },
  login: {
    title: 'Sign in to fleetster',
    description: 'Use your account to continue.',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    submit: 'Sign in',
    submitting: 'Signing in…',
    failed: 'Login failed.',
    quickLoginAriaLabel: 'Quick login',
  },
  quickLogin: {
    title: 'Quick login',
    description: 'Pick a seeded user to fill in the credentials and sign in. Every account uses the password',
  },
  gate: {
    title: 'No workspace available',
    description:
      'Your account isn’t linked to any organization yet, so onboarding can’t continue. Please contact support to get access.',
  },
  onboarding: {
    title: 'Welcome to fleetster',
    description: 'Let’s finish setting up your account before you continue.',
  },
  pending: {
    title: 'Waiting for activation',
    description:
      'Your access to {{workspace}} is pending. An administrator needs to activate you before you can continue.',
    fallbackWorkspace: 'this workspace',
  },
  deactivated: {
    title: 'Account deactivated',
    description: 'Your account has been deactivated. Please contact support to reactivate it.',
  },
  noTenants: {
    title: 'No tenants linked',
    description: 'There are no organizations linked to your account. Please contact support if you expected access.',
  },
  serverError: {
    title: 'Can’t reach the server',
    description: 'We couldn’t load your session. Please check your connection and try again.',
  },
  tenants: {
    title: 'Choose a workspace',
    description: 'Select the organization you want to work in. Inactive or pending workspaces can’t be entered yet.',
  },
  revocation: {
    toast: 'Your data-sharing access to {{tenant}} has ended. Switching you to {{home}}.',
  },
};

export type AuthResources = typeof auth;
